module.exports = __webpack_public_path__ + "static/media/main.a2732395.png";